import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

Alpine.data('ListingCarousel', () => ({
    init(){
        const swiper = new Swiper('.listingCarousel', {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                        ' of ' +
                        '<span class="' + totalClass + '"></span>';
                },
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1280: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1440: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            }
        });

    }
}))